
export const customRoute = (url: string) => {
    const newUrl = window.location.protocol + '//' + window.location.host + url
    window.location.href = newUrl
}